import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [resetUrl, setResetUrl] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);
    setResetUrl(null);

    try {
      const response = await api.post('/auth/forgot-password', { email });
      setSuccess(true);

      // In development, the backend returns the reset URL
      if (response.data.data.resetUrl) {
        setResetUrl(response.data.data.resetUrl);
      }
    } catch (err: any) {
      setError(
        err.response?.data?.error?.message || 'Failed to send reset link'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-card">
        <div className="forgot-password-header">
          <h1>Forgot Password</h1>
          <p>Enter your email address and we&apos;ll send you a link to reset your password</p>
        </div>

        {!success ? (
          <form onSubmit={handleSubmit} className="forgot-password-form">
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                dir="ltr"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
                placeholder="admin@zippel.co.il"
                autoFocus
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" className="btn-submit" disabled={loading || !email}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>

            <div className="form-footer">
              <button
                type="button"
                onClick={() => navigate('/login')}
                className="link-button"
              >
                Back to Login
              </button>
            </div>
          </form>
        ) : (
          <div className="success-state">
            <div className="success-icon">✓</div>
            <h2>Check Your Email</h2>
            <p>
              If an account exists for <strong>{email}</strong>, you will receive a
              password reset link shortly.
            </p>
            <p className="success-hint">
              The link will expire in 1 hour for security reasons.
            </p>

            {resetUrl && (
              <div className="dev-info">
                <p className="dev-label">Development Only:</p>
                <div className="reset-url-box">
                  <input
                    type="text"
                    value={resetUrl}
                    readOnly
                    onClick={(e) => (e.target as HTMLInputElement).select()}
                  />
                  <button
                    onClick={() => {
                      const token = new URL(resetUrl).searchParams.get('token');
                      navigate(`/reset-password?token=${token}`);
                    }}
                  >
                    Go to Reset
                  </button>
                </div>
              </div>
            )}

            <button
              onClick={() => navigate('/login')}
              className="btn-primary"
            >
              Return to Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
